
//filter controls need to be optional
//can init with filters
//store call for skills
//clear button



var WorkCollection = function(options){
    var oThis = this;

    oThis.defaults = {
        can_edit: false,
        portfolioid: null,
        collectionid: -1,
        filtercontrols: true,
        showOnEmpty: true,
        params: null
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.noncurated = oThis.settings.collectionid == 0;
    oThis.fullset = oThis.settings.collectionid == -1;
    oThis.bCanManage = mantl.userid == mantl.portfolio_user_user;
    oThis.Actions = Reflux.createActions(['fetchWork', 'fetchSkills']);
    oThis.containerID;
    oThis.modalsID = "workCollectionModal";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.WorkCollection = createReactClass({
        mixins: [Reflux.connect(oThis.WorkStore, 'work')],
        componentDidUpdate: function(){
            var $component = $(ReactDOM.findDOMNode(this));
            reactFixRowsCols($component);
            //$manager.find('.collapsible').collapsible();
        },

        getInitialState: function() {
            return {
                filters: {
                    open: false
                }
            }
        },

        handleToggleFilters: function(page) {
            this.setState({
                filters: {
                    open: !this.state.filters.open
                }
            });

        },

        render: function() {
            var oComponent = this;
            var emptyMsg = (oThis.settings.params != null) ? "No work samples found." : "No work has been added.";

            if(this.state.work){
                var workCols = (this.state.filters.open) ? 9 : 12;
                var work = [];
                for(var i = 0; i < this.state.work.items.length; i++){
                    var oItem = this.state.work.items[i];
                    work.push(<oThis.WorkCollectionItem item={oItem} key={oItem.id} />);
                }
                if(work.length == 0 && !oThis.settings.showOnEmpty){
                    return (null);
                } else {
                    return (
                        <div className="portfolio-content-work">
                            {(function(){
                                if (oThis.settings.filtercontrols) {
                                return (<div>
                                    <a className="button--flat button--skinny sidebar-trigger" onClick={oComponent.handleToggleFilters} href="#filtersWork"><i aria-hidden="true" className="icon-sliders"></i> Filters</a>
                                </div>);
                                }
                            })()}
                            <br />
                            <div data-row="row">
                                {(function(){
                                    if (oComponent.state.filters.open) {
                                    return (<oThis.WorkCollectionFilters />);
                                    }
                                })()}

                                <div data-column={workCols}>
                                    {(function(){
                                        if (work.length > 0) {
                                            hideOnboarding();
                                        return work;
                                    } else {
                                        return (<div className="alert alert--information text--xl"><h1 className="text--center h2">{emptyMsg}</h1> <img src={mantl.static_url + "assets/images/icon-collection.svg" } className="image--onboarding" alt="Collection Image" /></div>);
                                    }
                                    })()}
                                </div>

                            </div>
                        </div>
                    );
                }

            } else {
                return (
                    <div className="portfolio-content-work">
                        <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                    </div>
                );
            }

        }
    });

    oThis.WorkCollectionFilters = createReactClass({
        mixins: [Reflux.connect(oThis.SkillsStore, 'skills')],

        getInitialState: function() {
            return {
                datepickers: false
            }
        },

        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            reactFixRowsCols($component);
        },

        componentDidUpdate: function() {
            if(this.state.skills && !this.state.datepickers){
                pickerFrom = new Pikaday({
                    field: document.getElementById('date_from'),
                    defaultDate: new Date()
                });
                pickerTo = new Pikaday({
                    field: document.getElementById('date_to'),
                    defaultDate: new Date()
                });

                this.setState({
                    datepickers: true
                });
            }
        },

        handleFilter: function() {
            oThis.settings.params = $("#filters").serializeObject();
            oThis.Actions.fetchWork();
        },

        handleClearFilter: function() {
            $("#filters input:checkbox").prop('checked',false);
            oThis.settings.params = null;
            oThis.Actions.fetchWork();
        },

        render: function() {
            var oComponent = this;
            if(this.state.skills){

                var skills = [];
                for(var i = 0; i < this.state.skills.items.length; i++){
                    var oItem = this.state.skills.items[i];
                    if(oItem.work_count > 0){
                        skills.push(<oThis.WorkCollectionSkillCheckbox skill={oItem} />);
                    }
                }

                return (
                    <div id="filtersWork" data-column="3">
                        <form id="filters">
                            <ul className="collection">
                                <li className="collection-item">
                                    <h4>Date Added</h4>
                                    <div>
                                        <div className="input-group input--small">
                                            <label for="date_from" className="input-prefix input-prefix--date">From</label>
                                            <input type="text" id="date_from" name="date_from" className="datepicker" />
                                        </div>
                                        <div className="input-group input--small">
                                            <label for="date_to" className="input-prefix input-prefix--date">To</label>
                                            <input type="text"  id="date_to" name="date_to" className="datepicker" />
                                        </div>
                                    </div>
                                </li>
                                <li className="collection-item">
                                    <h4>Skills Reflected</h4>
                                    {skills}
                                </li>
                            </ul>
                        </form>

                        <button className="button--sm button--success" onClick={this.handleFilter}>Apply</button> <button className="button--sm" onClick={this.handleClearFilter}>Clear</button>
                    </div>
                );

            } else {
                return (
                    <div id="filtersWork" data-column="3"><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                )
            }



        }
    });

    oThis.WorkCollectionSkillCheckbox = createReactClass({
        render: function() {
            var oComponent = this;
            return (
                <div>
                    <input type="checkbox" name="skill" value={this.props.skill.tag} id={'skill_' + this.props.skill.id} /><label htmlFor={'skill_' + this.props.skill.id}><span className="flag flag--sm flag--muted">{this.props.skill.work_count}</span> {this.props.skill.tag}</label>
                </div>
            );

        }
    });


    //Set
    oThis.WorkCollectionItem = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        componentDidUpdate: function() {
        },

        handleViewClick: function(event) {
            var oComponent = this;
            event.preventDefault();

            //Build Modal
            httpGet(this.props.item.view_url, 'text/html, */*').then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full modal--flat',
                        header: "View Work Sample"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchWork();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading work view.', reason);
                    alertify.error('Unable to Open Work')
                });

        },

        handleEditClick: function(event) {
            event.preventDefault();
            //Build Modal
            httpGet(this.props.item.edit_url, 'text/html, */*').then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--large',
                        header: "Edit Work Sample"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchWork();
                    })
                    $modal.openModal({ closeOnEsc: false });
                })
            .catch(
                function(reason) {
                    console.error('Error loading work edit.', reason);
                    alertify.error('Unable to Open Work Editor')
                });
        },

        render: function() {
            var oComponent = this;
            var description = "No description."
            if(this.props.item.description.length > 0) {
                description = this.props.item.description
            }

            //the image prop is actually the file; it could be a docx or pdf etc
            var showImage = false;
            var heartIcon = (this.props.item.liked) ? "icon-heart" : "icon-heart-o";
            var commentIcon = (this.props.item.commented) ? "icon-comment" : "icon-comment-o";
            var bValidURL = validateURL(this.props.item.image);
            var fileExt = this.props.item.image.split('.');
            fileExt = fileExt[fileExt.length - 1];
            fileExt = fileExt.toLowerCase();
            var originalExt = fileExt;

            //check if it's a preview domain
            previewDomains.forEach(function(element,index){
                if(oComponent.props.item.image.toLowerCase().indexOf(element) > -1) { fileExt = element; }
            });

            //if it wasn't a preview domain use file type, if none, use generic url
            if(fileExt == originalExt){
                var useIcon = false;
                iconExt.forEach(function(element,index){
                    if(fileExt == element) {
                        useIcon = true;
                    }
                });
                if(!useIcon){
                    //if it's an image, we can just show it
                    switch(fileExt) {
                        case "jpg":
                        case "jpeg":
                        case "png":
                        case "gif":
                        case "tiff":
                        case "png":
                        case "svg":
                            showImage = true;
                            break;
                        default:
                            showImage = false;
                            fileExt = "url";
                            break;
                    }
                }
            }

            var cardImageClasses = "card-preview card-preview--" + fileExt;

            return (
                <div className="card card--work" data-work-id={this.props.item.id}>
                    <div className="card-header">
                        <h3 className="h5 text--center">{this.props.item.title}</h3>
                    </div>

                    <button className={cardImageClasses} onClick={this.handleViewClick}>
                        {(function(){
                            if (showImage) {
                                return (<img src={oComponent.props.item.image} title={oComponent.props.item.description} />);
                            }
                        })()}
                        <div className="card-description">
                            <p>{description}</p>
                        </div>
                    </button>

                    <div className="card-footer">
                        <a href={this.props.item.view_url} onClick={this.handleViewClick} className="view-button button button--flat button--skinny"><i title="Likes" className={heartIcon}></i> {this.props.item.like_count} <i title="Comments" className={commentIcon}></i> {this.props.item.comment_count}</a>
                        {(function(){
                            if (oThis.bCanManage) {
                                return (<a href={oComponent.props.item.edit_url} onClick={oComponent.handleEditClick} className="edit-button button button--sm button--skinny float--right">Edit Work</a>);
                            }
                        })()}
                    </div>
                </div>
            );

        }
    });


};

WorkCollection.prototype.renderCollection = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.WorkCollection />, document.getElementById(this.containerID));
}

//REFLUX STORE
WorkCollection.prototype.createStore = function() {
    var oThis = this;

    oThis.WorkStore = Reflux.createStore({
        listenables: oThis.Actions,
        work: {}, //work store

        init: function() {
        },

        getInitialState: function() {
            this.onFetchWork();
        },

        onFetchWork: function() {
            var oStore = this;
            var endpoint;
            if(oThis.fullset){
                endpoint = buildRoute(mantlroutes.portfolio_work,{ portfolioid: oThis.settings.portfolioid });
            } else if(oThis.noncurated){
                endpoint = buildRoute(mantlroutes.portfolio_noncurated_work,{ portfolioid: oThis.settings.portfolioid });
            } else {
                endpoint = buildRoute(mantlroutes.portfolio_collection_work,{ portfolioid: oThis.settings.portfolioid, collectionid: oThis.settings.collectionid });
            }
            if(oThis.settings.params != null){
                endpoint += formatParams(oThis.settings.params);
            }
            httpGet(endpoint).then(
                function(value) {
                    oStore.work.items = JSON.parse(value);
                    oStore.trigger(oStore.work);
                })
            .catch(
                function(reason) {
                    console.error('Error loading work items.', reason);
                    alertify.error('Unable to load work items.')
                });
        }

    });

    if(oThis.settings.filtercontrols) {
        oThis.SkillsStore = Reflux.createStore({
            listenables: oThis.Actions,
            skills: {}, //store

            init: function() {
            },

            getInitialState: function() {
                this.onFetchSkills();
            },

            onFetchSkills: function() {
                var oStore = this;
                var endpoint;
                if(oThis.fullset){
                    endpoint = buildRoute(mantlroutes.portfolio_skills,{ portfolioid: oThis.settings.portfolioid });
                } else if(oThis.noncurated){
                    endpoint = buildRoute(mantlroutes.portfolio_noncurated_skills,{ portfolioid: oThis.settings.portfolioid });
                } else {
                    endpoint = buildRoute(mantlroutes.portfolio_collection_skills,{ portfolioid: oThis.settings.portfolioid, collectionid: oThis.settings.collectionid });
                }

                httpGet(endpoint).then(
                    function(value) {
                        oStore.skills.items = JSON.parse(value);
                        oStore.trigger(oStore.skills);
                    })
                .catch(
                    function(reason) {
                        console.error('Error loading collection skills.', reason);
                        alertify.error('Unable to load collection skills list.')
                    });
            }

        });
    }

}
